import { render, staticRenderFns } from "./MoleculeEditionProductSalesLettersModalDelete.vue?vue&type=template&id=5b847b3d&"
import script from "./MoleculeEditionProductSalesLettersModalDelete.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductSalesLettersModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports